import { PushNotifications } from '@capacitor/push-notifications';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../config/firebase.config';
import { isCapacitorNative } from '../utils/nativePlatform';

class NativePushService {
  private registered = false;

  async ensureSetup(): Promise<void> {
    if (!isCapacitorNative()) return;

    try {
      const result = await PushNotifications.requestPermissions();
      if (result.receive !== 'granted') {
        console.log('Native push permission denied');
        return;
      }

      await PushNotifications.register();

      if (this.registered) return;
      this.registered = true;

      PushNotifications.addListener('registration', async (token) => {
        console.log('📱 Native FCM token:', token.value);
        await this.saveToken(token.value);
      });

      PushNotifications.addListener('registrationError', (err) => {
        console.error('Native FCM registration error:', err.error);
      });

      PushNotifications.addListener('pushNotificationReceived', (notification) => {
        console.log('📬 Native foreground notification:', notification);
      });

      PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
        console.log('👆 Native notification tapped:', action);
      });
    } catch (error) {
      console.warn('Native push setup failed:', error);
    }
  }

  private async saveToken(token: string): Promise<void> {
    const user = auth.currentUser;
    if (!user) return;
    try {
      await updateDoc(doc(db, 'riders', user.uid), {
        fcmToken: token,
        fcmTokenNative: true,
        fcmTokenUpdatedAt: serverTimestamp(),
        notificationsEnabled: true,
      });
    } catch (err) {
      console.error('Failed to save native FCM token:', err);
    }
  }
}

export const nativePushService = new NativePushService();
